var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "akl" }, [
    _c(
      "div",
      {
        staticClass: "layerWrapper pop_eyecare",
        staticStyle: { display: "none" },
        attrs: { tabindex: "0" }
      },
      [
        _c(
          "div",
          { staticClass: "cbox layerBox popWidM" },
          [
            _vm.showMode === 0
              ? _c("TripleEyeIntro", { on: { clickStart: _vm.start } })
              : _vm._e(),
            _vm._v(" "),
            _vm.showMode === 1
              ? _c("TripleEyeQuest1", { on: { clickNext: _vm.goNext } })
              : _vm._e(),
            _vm._v(" "),
            _vm.showMode === 2
              ? _c("TripleEyeQuest2", {
                  attrs: { selectedScore: _vm.selectedScore },
                  on: { clickNext: _vm.goResult }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showMode === 3
              ? _c("TripleEyeResult", {
                  attrs: { score: _vm.score, devMode: _vm.devMode },
                  on: { clickResult: _vm.goRoulette, clickReset: _vm.init }
                })
              : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b5faf67", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5faf67","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/triple-eye-care/tripleEyeCare.vue
// module id = null
// module chunks = 